import { render, staticRenderFns } from "./MyOrder.vue?vue&type=template&id=12caf21f&scoped=true"
import script from "./MyOrder.vue?vue&type=script&lang=js"
export * from "./MyOrder.vue?vue&type=script&lang=js"
import style0 from "./MyOrder.vue?vue&type=style&index=0&id=12caf21f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12caf21f",
  null
  
)

export default component.exports